"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _footerTop = _interopRequireDefault(require("../styles/footer-top.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
var FooterAccordion = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(FooterAccordion, _React$Component);
  function FooterAccordion(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      isOpen: true
    };
    return _this;
  }
  var _proto = FooterAccordion.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var forcedOpen = this.props.forcedOpen;
    if (forcedOpen === false) {
      /* eslint-disable */
      this.setState({
        isOpen: false
      });
      /* eslint-enable */
    }
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var forcedOpen = this.props.forcedOpen;
    if (prevProps.forcedOpen !== forcedOpen) {
      /* eslint-disable */
      this.setState({
        isOpen: forcedOpen
      });
      /* eslint-enable */
    }
  };
  _proto.toggleState = function toggleState() {
    var forcedOpen = this.props.forcedOpen;
    var isOpen = this.state.isOpen;
    if (!forcedOpen) {
      this.setState({
        isOpen: !isOpen
      });
    }
  };
  _proto.publishDataToDataLayer = function publishDataToDataLayer(e, linkUrl, linkLabel) {
    var _this$props = this.props,
      market = _this$props.market,
      heading = _this$props.heading;
    if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
      if (['/empresa/contacto', '/empresa/contactar', '/ota-yhteytta'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'contact_form_click',
          comp_page: {
            position: 'bottom menu'
          }
        });
      }
      if (['/concesionarios', '/localizador-concessionarios', '/loyda-lahin-jalleenmyyjasi'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'dealer_locator_click',
          comp_page: {
            position: 'bottom menu'
          }
        });
      }
      if (['/comprar/configurador', '/loquiero/configurador', '/osta/rakenna-oma-mitsubishi', '/osta/rakenna-oma-mitsubishi/rakenna-autosi'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'car_configuration_click',
          comp_product: {
            position: 'bottom menu',
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: null,
            version: null,
            color: null,
            upholstery: null,
            accesories: null,
            fuel_type: null,
            price: null,
            currency: null
          }
        });
      }
      if (['/servicio/citataller', '/omistajuus/varaa-huolto'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'maintenance_request_click',
          comp_product: {
            position: 'bottom menu',
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: null,
            version: null,
            fuel_type: null,
            dealer_name: null
          }
        });
      }
      if (['/prueba', '/test-drive', '/varaa-koeajo'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'test_drive_request_click',
          comp_product: {
            position: 'bottom menu',
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: null,
            version: null,
            fuel_type: null,
            dealer_name: null
          }
        });
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'footer_click',
        comp_page: {
          main_category: heading ? heading.toLowerCase() : null,
          selected_category: linkLabel ? linkLabel.toLowerCase() : null
        }
      });
    }
    if (market.toLowerCase() === 'nl' && typeof window !== 'undefined' && window.dataLayer) {
      if (['/aanschaf/financiering'].includes(linkUrl)) {
        window.dataLayer.push({
          event: 'financingApplication',
          location: 'footer_menu'
        });
      }
    }
  };
  _proto.renderLinks = function renderLinks(links) {
    var _this2 = this;
    return links && links.map(function (link, i) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        className: _footerTop["default"].accordionListItem,
        key: i
      }, /*#__PURE__*/_react["default"].createElement("a", {
        target: "" + (link.openNewTab === true ? '_blank' : ''),
        className: _footerTop["default"].accordionLink,
        "data-section": "footer",
        href: handleNestedProp(link, 'link.url'),
        onClick: function onClick(e) {
          return _this2.publishDataToDataLayer(e, handleNestedProp(link, 'link.url'), handleNestedProp(link, 'link.label'));
        }
      }, handleNestedProp(link, 'link.label')));
    });
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props2 = this.props,
      heading = _this$props2.heading,
      theme = _this$props2.theme,
      links = _this$props2.links,
      iterator = _this$props2.iterator;
    var isOpen = this.state.isOpen;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.accordion + " " + _footerTop["default"].fullWidth,
      role: "tablist"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: _footerTop["default"].accordionButton + " " + theme.inputsAndOptions + " " + (isOpen ? _footerTop["default"].accordionActive : '') + " " + theme.mmcIconChevronDown,
      role: "tab",
      type: "button",
      id: "footer-acccordion-header-" + iterator,
      "aria-controls": "footer-acccordion-panel-" + iterator,
      onClick: function onClick() {
        return _this3.toggleState();
      }
    }, heading)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _footerTop["default"].accordionPanel,
      id: "footer-acccordion-panel-" + iterator,
      role: "tabpanel",
      "aria-hidden": !isOpen
    }, /*#__PURE__*/_react["default"].createElement("ul", {
      className: _footerTop["default"].accordionListWrapper
    }, this.renderLinks(links))));
  };
  return FooterAccordion;
}(_react["default"].Component);
exports["default"] = FooterAccordion;
FooterAccordion.displayName = 'FooterAccordion';